import Container from "@mui/material/Container";

export default function ContainerBox(props) {
  const boxStyle = {
    maxWidth: { xs: "xs", sm: "sm", md: "md", lg: "lg", xl: "xl" },
    height: "100%",
  };

  return <Container sx={boxStyle}>{props.children}</Container>;
}
